import { PDP_SWATCH_NO_COLOUR } from '@adapters/bigcommerce/types/product';

/** Pipe-derived: no colour segment, empty, or explicit `NO_COLOUR` — product-wide lifestyle. */
export function isLfsProductScopedSwatch(
  swatchMatch: string | undefined
): boolean {
  return (
    swatchMatch == null ||
    swatchMatch === '' ||
    swatchMatch === PDP_SWATCH_NO_COLOUR
  );
}
